import { usePutHttp } from "../../http.hook";

interface IBody {
  visibleToBrand: string;
}

export function useChangePostVisibilityEphemeralHttp() {
  return usePutHttp<IBody, null>({
    path: "/ephemeral/brand-dash/posts/:id/change-visibility",
  });
}
